import React from "react";

export function LegalHero({ eyebrow = "Legal", title, intro }) {
    return (
        <section className="bg-charcoal text-offwhite pt-32 pb-14 md:pt-40 md:pb-20">
            <div className="max-w-[720px] mx-auto px-6 md:px-10">
                <p className="font-manrope font-semibold text-terracotta text-[12px] tracking-[0.22em] uppercase mb-4">
                    {eyebrow}
                </p>
                <h1 className="font-manrope font-bold text-offwhite text-[38px] md:text-[52px] leading-[1.05] tracking-tight mb-4">
                    {title}
                </h1>
                {intro && <p className="font-inter text-offwhite/70 text-[16px] md:text-[18px] leading-relaxed">{intro}</p>}
            </div>
        </section>
    );
}

export function LegalBody({ children }) {
    return (
        <section className="bg-offwhite py-16 md:py-24">
            <div className="max-w-[720px] mx-auto px-6 md:px-10 font-inter text-[17px] leading-[1.75] text-charcoal/85 space-y-5 legal-prose">
                {children}
            </div>
        </section>
    );
}

export function Placeholder({ children }) {
    return (
        <span className="inline-block px-1.5 py-0.5 bg-terracotta/10 text-terracotta font-manrope font-semibold text-[13px] rounded">
            {children}
        </span>
    );
}

export function H2({ children }) {
    return <h2 className="font-manrope font-bold text-charcoal text-[24px] md:text-[28px] mt-12 mb-4 leading-tight">{children}</h2>;
}
export function H3({ children }) {
    return <h3 className="font-manrope font-semibold text-charcoal text-[18px] md:text-[19px] mt-8 mb-3">{children}</h3>;
}
export function LastUpdated({ date = "3 February 2026" }) {
    return <p className="font-inter text-charcoal/50 text-[14px] italic">Last updated: {date}</p>;
}
